export function shouldShowProductSubtypeAction(item) {
  return item?.categoryTitle === 'Product' && Boolean(item?.key);
}

export function isNewProductType(productType, options = []) {
  const normalizedType = String(productType || '').trim().toLowerCase();
  if (!normalizedType) return false;

  return !options.some((option) =>
    String(option || '').trim().toLowerCase() === normalizedType,
  );
}

export function getProductSubtypeRows(productTypes = [], productSubtypeMap = {}) {
  return productTypes.flatMap((productType) =>
    (productSubtypeMap[productType] || []).map((productSubtype) => ({
      productType,
      productSubtype,
    })),
  );
}

export function getProductSubtypeOptions(productCategory, productType, productSubtypeMap = {}, subtypeRows = []) {
  if (!productType) return [];

  const mappedOptions = Array.isArray(productSubtypeMap[productType])
    ? productSubtypeMap[productType]
    : [];

  if (productCategory !== 'Insurance' || !Array.isArray(subtypeRows) || subtypeRows.length === 0) {
    return [...new Set(mappedOptions.filter(Boolean))];
  }

  const matchingRows = subtypeRows.filter((row) => row?.productType === productType);
  if (matchingRows.length === 0) {
    return [...new Set(mappedOptions.filter(Boolean))];
  }

  return [...new Set(
    matchingRows
      .filter((row) => row.isActive !== false)
      .map((row) => row.productSubtype)
      .filter(Boolean),
  )];
}

export function createProductDisplayFields() {
  return {
    nameCN: '',
    imageFiles: { th: [], en: [], cn: [] },
    imagePreviews: { th: [], en: [], cn: [] },
    isTaxPlanning: false,
    keyHighlightLanguage: 'th',
    keyHighlights: { th: '', en: '', cn: '' },
    linkToBuy: '',
  };
}

export function createProductImagePreviews(url, languageKey) {
  if (!url) return [];

  return [{
    name: `Image_${String(languageKey || '').toUpperCase()}`,
    src: url,
    existing: true,
  }];
}

export function isKeyHighlightVisible(item) {
  return Boolean(item?.isTaxPlanning);
}

export function buildMetaDocProductFormData(values = {}, imageFiles = {}) {
  const formData = new FormData();

  Object.entries(values).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    // array ต้อง append ทีละตัวด้วย key เดิมซ้ำ ๆ — ASP.NET ถึงจะ bind เข้า List<string> ได้
    // ถ้าใช้ String(value) จะได้ "a,b" สตริงเดียว แล้วฝั่ง backend ได้สมาชิกเดียวที่มีคอมมาอยู่ข้างใน
    if (Array.isArray(value)) {
      value
        .filter((item) => item !== null && item !== undefined && item !== '')
        .forEach((item) => formData.append(key, String(item)));
      return;
    }

    formData.append(key, String(value));
  });

  [
    ['imageTH', imageFiles.th],
    ['imageEN', imageFiles.en],
    ['imageCN', imageFiles.cn],
  ].forEach(([fieldName, files]) => {
    const file = Array.isArray(files) ? files[0] : files;
    if (file) formData.append(fieldName, file);
  });

  return formData;
}
